import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_FASHIONPHILE_API_URL,
  headers: {
    Accept: 'application/x.fashionphile.v1+json'
  }
})

api.interceptors.request.use(async config => {
  await window.isClerkLoaded
  const token = await window.Clerk.session?.getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
